import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import CategoryViewModal from "../../../components/categoryViewModal";
import { categoryList, deleteCategory, toggleCategory } from "./categorySlice";
import { useSelector } from "react-redux";
import Pagination from "react-js-pagination";
import DeleteModal from "../../../components/deleteModal";
import { toast } from "react-toastify";
import { useCallback } from "react";
import { debounce } from "lodash";
// import 'bootstrap/dist/css/bootstrap.min.css';

const CategoryList = () => {
  const dispatch = useDispatch();
  const History = useHistory();
  const [modal, setModal] = useState(false);
  const [id, setDeleteId] = useState("");
  const [filters, setFilters] = useState({
    page: 1,
    limit: 10,
    search: "",
    active: 1,
  });
  const data = useSelector((state) => state.category.categoryList.data);
  const total = useSelector((state) => state.category.categoryList.total);
  const toggleTab = (val) => {
    setFilters({
      ...filters,
      active: val,
      page: 1,
    });
  };

  const listing = useCallback(() => {
    dispatch(categoryList(filters));
  }, [dispatch, filters]);

  useEffect(() => {
    listing();
  }, [listing]);

  const handlePageChange = (pageNumber) => {
    setFilters({
      ...filters,
      page: pageNumber,
    });
  };

  const handleChange = debounce((e) => {
    setFilters({
      ...filters,
      search: e.target.value,
    });
  }, 300);

  const toggle = () => {
    setModal(!modal);
  };

  const deleteCat = () => {
    dispatch(deleteCategory({ id })).then((data) => {
      if (data?.payload?.response_code === 200) {
        toggle();
        toast.success("Success");
      } else {
        toast.error(data?.payload?.message);
      }
    });
  };

  const handleToggle = (id) => {
    dispatch(
      toggleCategory(
        {
          id,
        },
        { dispatch }
      )
    ).then((data) => {
      if (data && data.payload.response_code === 200) {
        dispatch(categoryList(filters));
        toast.success(data.payload.message);
      } else {
        toast.error(data.payload.message);
      }
    });
  };

  return (
    <article class="col-lg-9">
      <div class="article-body store-bd-gy">
        <div class="row align-items-center col-rever">
          <div class="col-sm-12 col-md-6 col-lg-6 mb-3">
            <div class="link-active">
              <img alt="" src="assets/images/Categories-selected.png" />
              <span>
                <p>{total && total}</p>
                <p>Total Categories</p>
              </span>
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-6 mb-3">
            <div class="d-flex align-items-center lg-justify-content-end">
              <form class="has-search">
                <span class="form-search-icon form-control-feedback"></span>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search Categories by name"
                  onChange={handleChange}
                />
              </form>
              <Link to="/admin/category/add" class="add-new">
                + Add New
              </Link>
            </div>
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-sm-12 col-md-6 col-lg-5 mb-3">
            <ul class="nav nav-tabs group-nav" role="tablist">
              <li class="nav-item">
                <Link
                  className={`nav-link ` + (filters.active ? "active" : "")}
                  onClick={() => toggleTab(1)}
                  data-toggle="tab"
                  to="#"
                >
                  active
                </Link>
              </li>
              <li class="nav-item">
                <Link
                  className={`nav-link ` + (filters.active ? "" : "active")}
                  onClick={() => toggleTab(0)}
                  data-toggle="tab"
                  to="#"
                >
                  inactive
                </Link>
              </li>
            </ul>
          </div>
          <div class="col-sm-12">
            <div class="table-responsive text-center">
              <table class="table storetable">
                <thead class="text-center">
                  <tr>
                    <th scope="col">category image</th>
                    <th scope="col">category Name</th>
                    <th scope="col">rank</th>
                    <th scope="col">total sub-category</th>
                    <th scope="col">action</th>
                  </tr>
                  <tr class="border-0 bg-none invisible">
                    <td class="border-0 bg-none"></td>
                  </tr>
                </thead>
                <tbody>
                  {data && data.length > 0 ? (
                    data.map((data, i) => {
                      return (
                        <tr key={i}>
                          <td>
                            <div
                              style={{
                                height: "80px",
                                width: "80px",
                                margin: "0 auto",
                                borderRadius: "10px",
                                overflow: "hidden",
                              }}
                            >
                              <img
                                alt=""
                                src={data.image || "assets/images/employe.png"}
                                class="object-fit-cover"
                              />
                            </div>
                          </td>
                          <td>{data.name}</td>
                          <td>{data.rank}</td>
                          <td>{data.sub_category_count}</td>
                          <td>
                            <div class="d-flex justify-content-center action">
                              <CategoryViewModal id={data.id} />
                              <button
                                onClick={() =>
                                  History.push(
                                    `/admin/category/edit/${data.id}`
                                  )
                                }
                                class="btn"
                              >
                                <img alt="" src="assets/images/edit.png" />
                              </button>
                              <button class="btn">
                                <input
                                  checked={data?.active}
                                  onChange={() => handleToggle(data.id)}
                                  type="checkbox"
                                  id={data.id}
                                  class="toggle"
                                  alt=""
                                />
                              </button>
                              <button
                                onClick={() => {
                                  setDeleteId(data.id);
                                  toggle();
                                }}
                                class="btn"
                              >
                                <img alt="" src="assets/images/delete.png" />
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={5}>No Data Found.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {total && total > 10 ? (
          <div>
            <Pagination
              activePage={filters.page}
              itemsCountPerPage={filters.limit}
              totalItemsCount={total}
              pageRangeDisplayed={5}
              onChange={handlePageChange}
            />
          </div>
        ) : (
          ""
        )}
      </div>

      <DeleteModal deleteCategory={deleteCat} modal={modal} toggle={toggle} />
    </article>
  );
};

export default CategoryList;
